import { render } from "./RequestIndex.vue?vue&type=template&id=8c4fdf12&scoped=true"
import script from "./RequestIndex.vue?vue&type=script&lang=js"
export * from "./RequestIndex.vue?vue&type=script&lang=js"

import "./RequestIndex.vue?vue&type=style&index=0&id=8c4fdf12&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c4fdf12"]])

export default __exports__